(function () {
  if (window.__slideshowSectionInitialized) return;
  window.__slideshowSectionInitialized = true;

  /** Quando elementFromPoint devolve só o #Slider (filhos não recebem hit), escolhe o slide mais visível. */
  function getDominantSlideFromTrack(track) {
    var slides = Array.prototype.slice.call(track.children).filter(function (el) {
      return el.classList && el.classList.contains('slideshow__slide') && el.clientWidth > 0;
    });
    if (!slides.length) return null;

    var vpLeft = track.scrollLeft;
    var vpRight = track.scrollLeft + track.clientWidth;
    var best = slides[0];
    var bestVis = -1;

    slides.forEach(function (slide) {
      var left = slide.offsetLeft;
      var right = slide.offsetLeft + slide.clientWidth;
      var il = Math.max(left, vpLeft);
      var ir = Math.min(right, vpRight);
      var vis = Math.max(0, ir - il);
      if (vis > bestVis) {
        bestVis = vis;
        best = slide;
      }
    });

    if (bestVis <= 0 && slides.length > 1) {
      var span = slides[1].offsetLeft - slides[0].offsetLeft;
      if (span > 0) {
        var idx = Math.min(slides.length - 1, Math.max(0, Math.floor(track.scrollLeft / span)));
        best = slides[idx];
      }
    }

    return best;
  }

  function resolveSlideshowSlideUrl(slide, hitEl) {
    var url = '';
    var clickedA = hitEl.closest && hitEl.closest('a[href]');
    if (clickedA && slide.contains(clickedA)) {
      var h = clickedA.getAttribute('href');
      if (h && h !== '#' && h.indexOf('javascript:') !== 0) url = h.trim();
    }
    if (!url) {
      var ds = slide.getAttribute('data-slide-link');
      if (ds && ds !== '#') url = ds.trim();
    }
    if (!url) {
      var mediaA = slide.querySelector('a.slideshow__slide-link[href]');
      if (mediaA) {
        var hm = mediaA.getAttribute('href');
        if (hm && hm !== '#') url = hm.trim();
      }
    }
    if (!url) {
      var cta = slide.querySelector('.banner__buttons a.button[href]');
      if (cta) {
        var hc = cta.getAttribute('href');
        if (hc && hc !== '#') url = hc.trim();
      }
    }
    return url;
  }

  /**
   * Gambiarra definitiva: capture na fase document + elementFromPoint (pixel real).
   * Cobre event.target errado, overlays e handlers que roubam o clique.
   */
  function bindDocumentSlideshowNavHackOnce() {
    if (window.__slideshowDocumentNavHack) return;
    window.__slideshowDocumentNavHack = true;

    document.addEventListener(
      'click',
      function (ev) {
        try {
          if (!document.elementFromPoint) return;
          var hit = document.elementFromPoint(ev.clientX, ev.clientY);
          if (!hit || !hit.closest) return;

          if (hit.closest('.slider-button')) return;
          if (hit.closest('.slider-counter__link')) return;
          if (hit.closest('.tabs-scroll-arrow')) return;

          var slide = hit.closest('.slideshow__slide');
          var track = null;

          if (slide) {
            track = slide.closest('[id^="Slider-"]');
          } else if (
            hit.classList &&
            hit.classList.contains('slideshow') &&
            hit.classList.contains('banner') &&
            hit.id &&
            hit.id.indexOf('Slider-') === 0
          ) {
            track = hit;
            slide = getDominantSlideFromTrack(track);
          }

          if (!slide || !track || !track.classList.contains('slideshow')) return;
          if (!track.closest('.container-slideshow')) return;

          if (hit.closest('video, iframe')) return;

          var url = resolveSlideshowSlideUrl(slide, hit);
          if (!url) return;

          ev.preventDefault();
          ev.stopPropagation();
          ev.stopImmediatePropagation();
          window.location.assign(url);
        } catch (e) {}
      },
      true
    );
  }

  bindDocumentSlideshowNavHackOnce();

  function getSectionRoot(node) {
    return node && node.closest ? node.closest('[id^="shopify-section-"]') : null;
  }

  function clearAutoplay(root) {
    if (!root || !root.__slideshowAutoplayTimer) return;
    clearInterval(root.__slideshowAutoplayTimer);
    root.__slideshowAutoplayTimer = null;
  }

  function clearCountdownTimers(root) {
    if (!root || !root.__slideshowCountdownTimers) return;
    root.__slideshowCountdownTimers.forEach(function (timerId) {
      clearInterval(timerId);
    });
    root.__slideshowCountdownTimers = [];
  }

  function initAutoplay(container) {
    var root = getSectionRoot(container);
    var slider = container.querySelector('[id^="Slider-"]');

    if (!root || !slider) return;

    clearAutoplay(root);

    if (slider.getAttribute('data-slideshow-autoplay') !== 'true') return;
    if (parseInt(slider.getAttribute('data-slideshow-visible-count'), 10) < 2) return;

    var nextButton = container.querySelector('.slideshow__controls .slider-button--next');
    if (!nextButton) return;

    var speed = parseInt(slider.getAttribute('data-slideshow-speed'), 10);
    if (!speed || speed < 1) speed = 5;
    speed = speed * 1000;

    root.__slideshowAutoplayStart = function () {
      if (root.__slideshowAutoplayPaused) return;
      clearAutoplay(root);
      root.__slideshowAutoplayTimer = setInterval(function () {
        nextButton.click();
      }, speed);
    };

    if (!root.__slideshowAutoplayBound) {
      root.__slideshowAutoplayBound = true;
      root.__slideshowAutoplayPaused = false;

      root.addEventListener('mouseenter', function () {
        root.__slideshowAutoplayPaused = true;
        clearAutoplay(root);
      });

      root.addEventListener('mouseleave', function () {
        root.__slideshowAutoplayPaused = false;
        if (typeof root.__slideshowAutoplayStart === 'function') root.__slideshowAutoplayStart();
      });

      root.addEventListener('focusin', function () {
        root.__slideshowAutoplayPaused = true;
        clearAutoplay(root);
      });

      root.addEventListener('focusout', function () {
        root.__slideshowAutoplayPaused = false;
        if (typeof root.__slideshowAutoplayStart === 'function') root.__slideshowAutoplayStart();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          clearAutoplay(root);
        } else if (!root.__slideshowAutoplayPaused && typeof root.__slideshowAutoplayStart === 'function') {
          root.__slideshowAutoplayStart();
        }
      });
    }

    root.__slideshowAutoplayStart();
  }

  function initCountdown(container) {
    var root = getSectionRoot(container);
    var countdownEls = container.querySelectorAll('.slideshow-countdown[data-countdown-end]');

    if (!root) return;

    clearCountdownTimers(root);

    if (!countdownEls.length) return;

    root.__slideshowCountdownTimers = [];

    countdownEls.forEach(function (el) {
      var endStr = el.getAttribute('data-countdown-end');
      if (!endStr) return;

      var endDate = new Date(endStr);
      if (isNaN(endDate.getTime())) return;

      var hoursEl = el.querySelector('[data-unit="hours"]');
      var minutesEl = el.querySelector('[data-unit="minutes"]');
      var secondsEl = el.querySelector('[data-unit="seconds"]');

      if (!hoursEl || !minutesEl || !secondsEl) return;

      function pad(num) {
        return num < 10 ? '0' + num : String(num);
      }

      function tick() {
        var now = new Date();
        var diff = endDate.getTime() - now.getTime();

        if (diff <= 0) {
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          clearInterval(intervalId);
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      tick();
      var intervalId = setInterval(tick, 1000);
      root.__slideshowCountdownTimers.push(intervalId);
    });
  }

  function initTabsScroll(container) {
    container.querySelectorAll('[data-tabs-scroll]').forEach(function (btn) {
      if (btn.dataset.slideshowTabsBound === 'true') return;
      btn.dataset.slideshowTabsBound = 'true';

      btn.addEventListener('click', function () {
        var controls = btn.closest('.slideshow__controls');
        var nextBtn = controls ? controls.querySelector('.slider-button--next') : null;
        if (nextBtn) nextBtn.click();
      });
    });
  }

  function initSlideLinks(container) {
    container.querySelectorAll('[data-slide-link]').forEach(function (slide) {
      if (slide.dataset.slideshowSlideLinkBound === 'true') return;
      slide.dataset.slideshowSlideLinkBound = 'true';

      function startTracking(clientX, clientY) {
        slide.__slideshowPointerStart = {
          x: clientX,
          y: clientY,
          moved: false,
        };
      }

      function trackMovement(clientX, clientY) {
        if (!slide.__slideshowPointerStart) return;

        var deltaX = Math.abs(clientX - slide.__slideshowPointerStart.x);
        var deltaY = Math.abs(clientY - slide.__slideshowPointerStart.y);

        if (deltaX > 8 || deltaY > 8) {
          slide.__slideshowPointerStart.moved = true;
        }
      }

      function finishTracking() {
        if (!slide.__slideshowPointerStart || !slide.__slideshowPointerStart.moved) return;
        slide.__slideshowPreventClickUntil = Date.now() + 250;
      }

      function clearTracking() {
        slide.__slideshowPointerStart = null;
      }

      slide.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        startTracking(event.clientX, event.clientY);
      });

      slide.addEventListener('pointermove', function (event) {
        trackMovement(event.clientX, event.clientY);
      });

      slide.addEventListener('pointerup', function () {
        finishTracking();
        clearTracking();
      });

      slide.addEventListener('pointercancel', function () {
        clearTracking();
      });

      slide.addEventListener(
        'touchstart',
        function (event) {
          var touch = event.touches && event.touches[0];
          if (!touch) return;
          startTracking(touch.clientX, touch.clientY);
        },
        { passive: true }
      );

      slide.addEventListener(
        'touchmove',
        function (event) {
          var touch = event.touches && event.touches[0];
          if (!touch) return;
          trackMovement(touch.clientX, touch.clientY);
        },
        { passive: true }
      );

      slide.addEventListener(
        'touchend',
        function () {
          finishTracking();
          clearTracking();
        },
        { passive: true }
      );

      slide.addEventListener('touchcancel', function () {
        clearTracking();
      });

      slide.addEventListener('click', function (event) {
        var interactiveTarget = event.target.closest('a, button, input, select, textarea, summary, label');

        if (interactiveTarget) {
          clearTracking();
          return;
        }

        if (slide.__slideshowPreventClickUntil && slide.__slideshowPreventClickUntil > Date.now()) {
          event.preventDefault();
          event.stopPropagation();
          clearTracking();
          return;
        }

        var link = slide.dataset.slideLink;
        clearTracking();
        if (link) {
          window.location.assign(link);
        }
      });
    });
  }

  function initSlideshowSection(scope) {
    var containers;

    if (scope && scope.matches && scope.matches('.container-slideshow')) {
      containers = [scope];
    } else {
      containers = (scope || document).querySelectorAll('.container-slideshow');
    }

    containers.forEach(function (container) {
      initAutoplay(container);
      initCountdown(container);
      initSlideLinks(container);
      initTabsScroll(container);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSlideshowSection(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.detail || !event.detail.sectionId) return;
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (root) initSlideshowSection(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.detail || !event.detail.sectionId) return;
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!root) return;
    clearAutoplay(root);
    clearCountdownTimers(root);
  });
})();
